'use client';

import { useEffect, useId } from 'react';
import Accordion, { type AccordionItem } from '~/components/primitives/Accordion';
import { useFaqSearchStore, useFaqIsSearching } from './FaqSearchContext';

export default function FaqSearchAccordion({
    items,
    color,
    sectionTitle = '',
}: {
    items: AccordionItem[];
    color: 'light' | 'dark';
    sectionTitle?: string;
}) {
    const sectionId = useId();
    const store = useFaqSearchStore();
    const isSearching = useFaqIsSearching();

    // Register this section's items with the store so the combined view can use them
    useEffect(() => {
        if (!store) return;
        return store.register(sectionId, { items, sectionTitle });
    }, [store, sectionId, items, sectionTitle]);

    // When searching, hide — combined results render in FaqTabsBlock
    if (isSearching) {
        return null;
    }

    return <Accordion items={items} color={color} />;
}
